var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.29166C9.99861 1.02658 8.97342 0.00138672 7.70834 0H2.29166C1.02658 0.00138672 0.00138672 1.02658 0 2.29166V2.70832C0.00015625 3.08898 0.149785 3.45437 0.41666 3.72582V7.70832C0.418047 8.97342 1.44326 9.99861 2.70834 10H7.29168C8.55676 9.99861 9.58197 8.97342 9.58334 7.70834V3.72584C9.85023 3.45439 9.99986 3.089 10 2.70834V2.29166ZM1.25 2.29166C1.25 1.71637 1.71637 1.25 2.29166 1.25H7.70832C8.28363 1.25 8.75 1.71637 8.75 2.29166V2.70832C8.75 2.82338 8.65672 2.91666 8.54166 2.91666H1.45834C1.34328 2.91666 1.25 2.82338 1.25 2.70832V2.29166ZM8.33334 7.70834C8.33334 8.28363 7.86697 8.75 7.29168 8.75H2.70834C2.13305 8.75 1.66668 8.28363 1.66668 7.70834V4.16666H8.33334V7.70834Z",
    fill: "#868E96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95825 5H6.0416C6.38677 5 6.6666 5.27982 6.6666 5.625C6.6666 5.97018 6.38677 6.25 6.0416 6.25H3.95825C3.61308 6.25 3.33325 5.97018 3.33325 5.625C3.33325 5.27982 3.61308 5 3.95825 5Z",
    fill: "#868E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesInactive);
export default __webpack_public_path__ + "static/media/FilesInactive.be0b03672ce266a17f8a5c500567c239.svg";
export { ForwardRef as ReactComponent };